import React from 'react'
import { useTranslation } from 'react-i18next'
import { get } from 'lodash'
import styled from 'styled-components'
import { Icon } from '@ui'

import { cssVariables } from '../../styles'
import { useCurrentMerchant, useCurrentUserMerchantRoles } from '../../hooks'

const NavItem = styled.div`
	cursor: ${props => (props.enabled ? 'pointer' : 'default')};
	padding: ${cssVariables.spacings.sm};
	display: flex;
	justify-content: center;
	align-items: center;

	filter: grayscale(100%);
	transition: filter 0.5s ease-in-out;

	&:hover {
		filter: grayscale(0%);
	}
`

const Name = styled.span`
	font-size: ${cssVariables.fontSizes.default};
	flex: 1 1 auto;
	font-weight: 500;
`

const NameStyled = styled(Name)`
	margin-right: ${cssVariables.spacings.xl};
`

export const MerchantNavItem = props => {
	const { t: translate } = useTranslation()
	const { data, loading } = useCurrentMerchant()

	const { connectedToOnlyOneMerchant, connectedToMultipleMerchants } = useCurrentUserMerchantRoles()

	const name = get(data, 'merchant.name')

	if (loading) return null

	return (
		<NavItem {...props} enabled={connectedToMultipleMerchants} tooltip={translate('merchantSelector.changeMerchant')} data-test-id="MerchantNavItem">
			{connectedToOnlyOneMerchant ? <Name> {name} </Name> : <NameStyled>{name || translate('merchantSelector.selectMerchant')}</NameStyled>}
			{connectedToMultipleMerchants && <Icon name="down" sm data-test-id="Icon" />}
		</NavItem>
	)
}
